<template>
  <v-card flat>
    <v-toolbar dense flat dark color="primary" class="mb-0">
      <v-toolbar-title class="body-2">{{ formTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
      <v-btn x-small icon @click="$emit('close')">
        <v-icon>fa fa-close</v-icon>
      </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text class="px-3" style="height:60vh">
    <v-tabs
      color="primary lighten-2 accent-4 "
      show-arrows
      next-icon="fa fa-angle-right"
      prev-icon="fa fa-angle-left "
      :hide-slider=true
      dense
      left
      v-model="t"
      px-0
      mx-0
    >
      <v-tab class="caption" >General</v-tab>
      <v-tab class="caption" >Autos</v-tab>
      <v-tab class="caption d-none" >Cod Relacionados</v-tab>
      <v-tab class="caption" >Cod Originales</v-tab>
      <v-tab class="caption" >Ficha Técnica</v-tab>
      <v-tab class="caption" >Imagenes</v-tab>
    </v-tabs>
    <v-tabs-items v-model="t" touchless >
      <!--TAB  GENERAL -->
      <v-tab-item >
        <v-container fluid class="py-0" >
          <v-row >
            <v-col cols="12" sm=4  class='caption text-truncate'>
              <v-text-field v-model="frm.codigo" filled label="Código" dense hide-details class="caption" readonly="" />
            </v-col>
            <v-col cols="12" sm=8  class='caption text-truncate'>
              <v-text-field v-model="frm.des" filled label="Descripción" dense hide-details class="caption" readonly="" />
            </v-col>
          </v-row>
          <v-row > 
            <v-col cols="12" sm=6 class='caption text-truncate'>
              <v-select 
                dense 
                hide-details 
                class="caption" 
                label="Marca" 
                :items="marcas"
                v-model="frm.marca"
                append-outer-icon="fa-refresh"
                @click:append-outer="loadMarcas()"
                clearable
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm=6 class='caption text-truncate'>
              <v-select 
                label="Categoría" 
                dense 
                hide-details 
                class="caption" 
                :items="categorias"
                v-model="frm.categoria"
                append-outer-icon="fa-refresh"
                @click:append-outer="loadCategorias()"
                clearable
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class='caption text-truncate'>
              <v-textarea
                v-model="frm.texto"
                label="Observaciones"
                filled
                dense
                auto-grow
                placeholder="Información adicional"
                class="caption"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm=6 class='body-2 text-truncate'>
              <v-text-field v-model="frm.precio" filled label="Precio" dense hide-details class="caption " readonly/>
            </v-col>
            <v-col cols="12"  class='caption text-truncate'>
              <v-checkbox v-model="frm.estado" hide-details class="body-2 py-2 my-0">
                <template v-slot:label>
                  <span class="caption">Habilitado</span>
                </template>  
              </v-checkbox>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <!--TAB AUTOS -->
      <v-tab-item >
        <Autos :items="frm.autos"/>
      </v-tab-item>
      <!--TAB COD RELACIONADOS -->
      <v-tab-item >
        <v-container fluid class="py-0">
          <v-row>
            <v-col cols="12" class='caption text-truncate py-0'>
              Hablar con franco relacion entre codigos propios y link
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <!--TAB COD EQUIV -->
      <v-tab-item >
        <CodigosEquiv 
          :items="frm.codigoEquiv"
        />
      </v-tab-item>
      <!--TAB DATOS TECNICOS -->
      <v-tab-item >
        <Titulos :items="frm.titulos" :categoriaID="frm.categoria"  :key="frm.categoria" />
      </v-tab-item>
      <!-- TAB IMAGENES -->
      <v-tab-item >
        <v-container fluid class="py-0">
          <v-row>
            <v-col cols="12" class='caption text-truncate py-0'>
              <Imagenes :items="frm.imagenes"  :codigo='frm.codigo' key="imagen" />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs-items>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary darken-1" text @click="close">Cancelar</v-btn>
      <v-btn color="primary darken-1" text @click="save" :loading="loadSave">Guardar</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import {mapGetters} from 'vuex'

  import CodigosEquiv from '@/components/Productos/CodigosEquiv'
  import Autos from '@/components/Productos/Autos'
  import Titulos from '@/components/Productos/Titulos'

  import Imagenes from '@/components/Productos/Imagenes'


  //import Producto from '@/components/Productos/Producto'

  export default {
    name: 'Producto',
    props:['idProducto',''],

    components: {
      CodigosEquiv,
      Autos,
      Titulos,
      Imagenes
    },

    data: () => ({
      t:null,

      producto:"",
      loadGrid:false,
      loadSave:false,

      //page: 1,
      //pageCount: 0,
      //itemsPerPage: 100,


      marcas:[],

      categorias:[],

      subcategorias:[],

      frm:{
        id:0,
        codigo:"",
        des:"",
        precio:0,
        estado:true,
        
        marca:null,
        categoria:null,
        subcategoria:undefined,
        texto:"",

        autos:[],
        codigoEquiv:[],
        titulos:[],
        imagenes:[]

      },

    }),
    created: function () {
      console.log("Componente creado")
      this.initialize()
    },
    mounted: function () {
      console.log("Componente mondado")
      //this.loadItems()
    },
    watch: {

    },

    methods: {
      async loadSubCategorias () {

        console.log("loadSubcategorias")
        this.subcategorias=[]

        let response
        let opt

        opt={
          method: 'GET', 
          mode: 'cors'
        }
        response = await fetch(`${this.ROOT_API}subcategorias/?categoriaID=${this.frm.categoria}`, opt);

        if (response.ok){
          let r=await response.json()
          this.subcategorias=r.map(item => {
            return {
              value:item.id,
              text:item.subcategoria.toUpperCase()
            }
          })
        }
      },
      async loadMarcas() {
        let response
        let opt

        opt={
          method: 'GET', 
          mode: 'cors'
        }

        //INI MARCA
        response = await fetch(`${this.ROOT_API}cms/marcas`, opt);

        if (response.ok){
          let r=await response.json()
          this.marcas=r.map(item => {
            return {
              value:item.id,
              text:item.marca.toUpperCase()
            }
          })
        }
        //FIN MARCA

      },
      async loadCategorias(){
        //INI CATEGORIA
        let response
        let opt

        opt={
          method: 'GET', 
          mode: 'cors'
        }
        response = await fetch(`${this.ROOT_API}categorias`, opt);

        if (response.ok){
          let r=await response.json()
          this.categorias=r.map(item => {
            return {
              value:item.id,
              text:item.categoria.toUpperCase()
            }
          })
        }
        //FIN CATEGORIA
      },

      async initialize () {


        //INI MARCA
        /*
        response = await fetch(`${this.ROOT_API}marcas`, opt);

        if (response.ok){
          let r=await response.json()
          this.marcas=r.map(item => {
            return {
              value:item.id,
              text:item.marca.toUpperCase()
            }
          })
        }
        */
        //FIN MARCA



        //INI CATEGORIA
        let response
        let opt

        opt={
          method: 'GET', 
          mode: 'cors'
        }
        /*
        response = await fetch(`${this.ROOT_API}categorias`, opt);

        if (response.ok){
          let r=await response.json()
          this.categorias=r.map(item => {
            return {
              value:item.id,
              text:item.categoria 
            }
          })
        }*/
        //FIN CATEGORIA

        //INI GRAL
        response = await fetch(`${this.ROOT_API}productos/${this.idProducto}`, opt);
        if (response.ok){
          let r=await response.json()


          this.frm.id=this.idProducto
          this.frm.codigo=r[0].codigo
          this.frm.des=r[0].des
          this.frm.texto=r[0].texto
          this.frm.precio=r[0].precio
          this.frm.marca =r[0].marcaID
          this.frm.categoria=r[0].categoriaID
          this.frm.subcategoria=r[0].subcategoriaID
          this.frm.estado=r[0].estado==1 ? true : false
        }
        //FIN GRAL


        this.loadMarcas()
        this.loadCategorias()
        this.loadSubCategorias()


        //INI AUTOS
        response = await fetch(`${this.ROOT_API}productos/${this.idProducto}/prod_autos`, opt);
        if (response.ok){
          let r=await response.json()


          this.frm.autos=r.map(a => {
            return {
              id:a.id,
              marca_value:a.marcaID,
              marca_text:a.marca,
              modelo_value:a.modeloID,
              modelo_text:a.modelo,
              fDesde:a.f_desde,
              fHasta:a.f_hasta,
              eje_value:a.ejeID,
              eje_text:a.eje,
              obs:a.texto,
              accion:"U"
            }
          })
          
        }
        
        //FIN AUTOS

        //INI EQUIV
        response = await fetch(`${this.ROOT_API}productos/${this.idProducto}/prod_equivalencias`, opt);
        if (response.ok){
          let r=await response.json()
          this.frm.codigoEquiv=r.map(a => {
            return {
              id:a.id,
              marca_value:a.marcaID,
              marca_text:a.marca,
              codigo:a.codigo,
              accion:"U"
            }
          })     
        }
        //FIN EQUIV

        //INI DATOS
        response = await fetch(`${this.ROOT_API}productos/${this.idProducto}/prod_datos`, opt);
        if (response.ok){
          let r=await response.json()
          this.frm.titulos=r.map(t => {
            return {
              id:t.id,
              tituloID:t.tituloID,
              descripcion:t.descripcion,
              tipo:t.tipo,
              valor1_value:t.itemID,
              valor1:t.text1,
              valor2:t.text2,
              valor3:t.text3,
              valor4:t.text4,
              valor5:t.text5,
              accion:"U"
            }
          }) 
        }
        //FIN DATOS
        
        //INI IMAGENES
        response = await fetch(`${this.ROOT_API}productos/${this.idProducto}/prod_imagenes`, opt);
        if (response.ok){
          let r=await response.json()
          this.frm.imagenes=r.map(i => {
            return {
              id:i.id,
              fileName:i.img,
              imagenID:'',
              image:`${i.path}${i.img}`,
              accion:"U"
            }
          }) 
        }

        //FIN IMAGENES
      },
/*
      search(){
        if(this.$refs.prod.$refs.input.value) this.producto=this.$refs.prod.$refs.input.value
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.items.indexOf(item)
        confirm('Seguro que desea eliminar prod seleccionado?') && this.items.splice(index, 1)
      },
*/


      close () {
        this.$emit('close')
      },

      async save () {

        //
        try
        {
          this.loadSave=true

          for ( let i=0; i<this.frm.imagenes.length;i++){
            //console.log("fileName-->",this.frm.imagenes[i].fileName)
            delete this.frm.imagenes[i].image
          }

          console.log(this.frm)
          let opt={
            method: 'PUT', 
            mode: 'cors',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },  
            body: JSON.stringify(this.frm)
          }
          let response = await fetch(`${this.ROOT_API}cms/productos/${this.idProducto}`, opt)


          this.close()
          this.$emit('reload')
        }
        catch(err) {
          console.log(err)
        }

        this.loadSave=false



        //this.close()
      },


      /*
      async loadItems (){
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        let response = await fetch(`${this.ROOT_API}productos`, opt);

        if (response.ok){
          let r=await response.json()
          this.items=r.map(item => {
            return {
              id:item.id,
              codigo:item.codigo,
              des:item.des,
              precio:item.precio,

              marca:'',//item.marca
              categoria:''
            }
          })
        }

      }
      */


    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),

      formTitle () {
        return this.idProducto === 0 ? 'Nueva Producto' : 'Editar Producto'
      },

    },
  }
</script>

<style scoped>

</style>
